module.exports = __webpack_public_path__ + "img/project_index.2378b434.png";